export const TipoDespesaOptions: any[] = [{_id: "0", status: 'Em Aberto'}, {_id: "1", status: 'Reembolsar'}, {_id: "2", status: 'Faturar'}];